module.exports = __webpack_public_path__ + "img/theme_modern.1d210d38.png";